import React from 'react';
import { motion } from 'framer-motion';
import { HardHat, Award, Wrench, ShieldCheck } from 'lucide-react';
const credentials = [{
  icon: HardHat,
  label: 'Años en obra real'
}, {
  icon: Wrench,
  label: 'Instalaciones residenciales'
}, {
  icon: ShieldCheck,
  label: 'Especialista en normativa AEA'
}, {
  icon: Award,
  label: 'Formador profesional'
}];
export function Teacher() {
  return <section id="docente" className="py-24 bg-ed-black relative border-t border-white/5" data-id="element-462">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-463">
        <div className="grid lg:grid-cols-[auto_1fr] gap-10 lg:gap-16 items-center" data-id="element-464">
          {/* Portrait card */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="relative mx-auto lg:mx-0" data-id="element-465">
            <div className="absolute inset-0 bg-ed-green/15 blur-3xl rounded-full pointer-events-none" data-id="element-466"></div>

            <div className="relative w-56 sm:w-64 aspect-[3/4] bg-ed-dark border border-zinc-800 rounded-3xl overflow-hidden shadow-2xl" data-id="element-467">
              {/* Avatar visual */}
              <div className="absolute inset-0 bg-gradient-to-br from-ed-darker via-ed-dark to-ed-black flex items-center justify-center" data-id="element-468">
                <div className="relative" data-id="element-469">
                  <div className="absolute inset-0 bg-ed-green/30 blur-2xl rounded-full" data-id="element-470"></div>
                  <div className="relative w-32 h-32 rounded-full bg-ed-dark border-2 border-ed-green/50 flex items-center justify-center shadow-[0_0_30px_rgba(163,255,18,0.3)]" data-id="element-471">
                    <HardHat className="w-16 h-16 text-ed-green" strokeWidth={1.5} data-id="element-472" />
                  </div>
                </div>
              </div>

              {/* Bottom label */}
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-ed-black via-ed-black/90 to-transparent p-5" data-id="element-473">
                <div className="text-[10px] font-bold uppercase tracking-widest text-ed-green mb-1" data-id="element-474">
                  Docente principal
                </div>
                <div className="text-white font-black text-lg uppercase leading-tight" data-id="element-475">
                  Academia ED
                </div>
                <div className="text-zinc-400 text-xs" data-id="element-476">
                  Electricista profesional
                </div>
              </div>

              {/* Corner badge */}
              <div className="absolute top-4 right-4 w-10 h-10 rounded-xl bg-ed-green/15 border border-ed-green/40 flex items-center justify-center backdrop-blur-sm" data-id="element-477">
                <ShieldCheck className="w-5 h-5 text-ed-green" data-id="element-478" />
              </div>
            </div>
          </motion.div>

          {/* Copy */}
          <div data-id="element-479">
            <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-480">
              Quién te enseña
            </span>
            <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-6" data-id="element-481">
              ¿Quién te va a <br className="hidden sm:block" data-id="element-482" />
              <span className="text-ed-green" data-id="element-483">enseñar?</span>
            </h2>

            <div className="space-y-4 text-zinc-300 leading-relaxed text-base sm:text-lg mb-8" data-id="element-484">
              <p data-id="element-485">
                Un docente con{' '}
                <span className="text-white font-semibold" data-id="element-486">
                  experiencia real en obra
                </span>
                , no un teórico de manual. Años de trabajo en instalaciones
                residenciales, criterio profesional formado en el campo y
                conocimiento actualizado de la normativa vigente.
              </p>
              <p className="text-zinc-400 text-base" data-id="element-487">
                Su enfoque es claro: enseñar a pensar como electricista, no a
                repetir pasos sin entender. Cada concepto se explica con casos
                reales y aplicaciones concretas que vas a usar en viviendas de
                verdad.
              </p>
            </div>

            <div className="grid sm:grid-cols-2 gap-3" data-id="element-488">
              {credentials.map((c, i) => {
              const Icon = c.icon;
              return <motion.div key={i} initial={{
                opacity: 0,
                y: 10
              }} whileInView={{
                opacity: 1,
                y: 0
              }} viewport={{
                once: true,
                margin: '-50px'
              }} transition={{
                duration: 0.4,
                delay: i * 0.08
              }} className="flex items-center gap-3 bg-ed-dark border border-zinc-800 rounded-xl p-3.5" data-id="element-489">
                    <div className="w-9 h-9 rounded-lg bg-ed-green/10 border border-ed-green/30 flex items-center justify-center shrink-0" data-id="element-490">
                      <Icon className="w-4 h-4 text-ed-green" data-id="element-491" />
                    </div>
                    <span className="text-zinc-200 font-semibold text-sm" data-id="element-492">
                      {c.label}
                    </span>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </div>
    </section>;
}